import { jsxs as r, jsx as t } from "react/jsx-runtime";
import o from "./mobile-drawer.module.less.js";
import { QuickFilters as h } from "../quick-filters/quick-filters.js";
import { Input as u } from "../../../../../components/form-elements/input/input.js";
import "react-hook-form";
import "react";
import "dayjs";
import { useTranslation as L } from "react-i18next";
import "../../../../../contexts/global-context.js";
import "motion/react";
import "../../../../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import "../../../../../components/form-elements/file-upload/file-upload.js";
import "../../../../../components/form-elements/select/select.js";
import "@radix-ui/react-slider";
import { Dialog as g } from "../../../../../components/elements/dialog/dialog.js";
import I from "../list-and-loader/list-and-loader.js";
const V = ({
  selectedFilters: e,
  quickFilters: a,
  stationRows: N,
  isOpen: n,
  onClose: S,
  onOpen: m,
  onClickOpenAllFilters: s,
  onChangeQuickFilters: l,
  onClickStation: C,
  onChangeSearchTermInput: f,
  onClickClearSearchTerm: p,
  searchTerm: i,
  geolocation: c,
  isLoadingGeolocation: A
}) => {
  const { t: d } = L(), v = e.size > 0, D = i && i.length > 0, E = v || D || !!c;
  return /* @__PURE__ */ r("div", { className: [o.wrapper, n ? "" : o.closed].join(" "), children: [
    /* @__PURE__ */ r("div", { className: o.actionArea, children: [
      /* @__PURE__ */ t(
        u.Search,
        {
          placeholder: d("FIND_STATION_SEARCH_PLACEHOLDER"),
          name: "searchStations",
          onFocus: m,
          value: i,
          onClickClear: p,
          inputClassName: o.input
        }
      ),
      a && /* @__PURE__ */ t(
        h,
        {
          quickFilterGroupName: "preview",
          onChangeQuickFilter: l,
          onClickOpenAllFilters: s,
          selectedFilters: e,
          quickFilters: a
        }
      )
    ] }),
    /* @__PURE__ */ r(
      g,
      {
        isOpen: n,
        isModal: !1,
        anchor: "bottom",
        onClose: S,
        contentClassName: o.dialogContent,
        children: [
          /* @__PURE__ */ r("div", { className: o.actionAreaInDialog, children: [
            /* @__PURE__ */ t(
              u.Search,
              {
                placeholder: d("FIND_STATION_SEARCH_PLACEHOLDER"),
                name: "searchStations",
                onFocus: m,
                onChange: f,
                value: i,
                onClickClear: p,
                inputClassName: o.input
              }
            ),
            a && /* @__PURE__ */ t(
              h,
              {
                quickFilterGroupName: "mobile",
                onChangeQuickFilter: l,
                onClickOpenAllFilters: s,
                selectedFilters: e,
                quickFilters: a
              }
            )
          ] }),
          /* @__PURE__ */ t("div", { className: o.listSection, children: /* @__PURE__ */ t(
            I,
            {
              isListingStations: E,
              isLoadingGeolocation: A,
              stationRows: N,
              onClickStation: C,
              geolocation: c
            }
          ) })
        ]
      }
    )
  ] });
};
export {
  V as MobileDrawer,
  V as default
};
